<template>
  <div class="fit-height">
    <!-- <nav-default></nav-default> -->
    <div v-if="!propertiesLoaded" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <div class="table-contatable-container">
      <md-progress-bar md-mode="indeterminate" class="absolute-progress" v-if="!propertiesLoaded"></md-progress-bar>
      <md-empty-state
        v-else-if="noProperties"
        md-icon="./static/add_listing.svg"
        md-label="You don't have any properties"
        md-description="Add your first property here."
      >
        <md-button @click="goToProperties()" class="md-primary play-cta-button makeup">Add Property</md-button>
      </md-empty-state>
      <div v-else>
        <GSTC :config="generalConfig" @state="onState" ref="gstc"></GSTC>
      </div>
      <md-button class="md-fab md-primary absolute-cta-fab" @click="toggleTutorial(true)">
        <md-icon>help_outline</md-icon>
      </md-button>
      <div class="tools-panel">
        <md-button class="md-fab md-mini" title="Reset zoom" @click="resetZoom">
          <md-icon>crop_free</md-icon>
        </md-button>
        <md-button
          class="md-fab md-mini"
          title="Center to current date"
          @click="centerToCurrentDate"
        >
          <md-icon>gps_fixed</md-icon>
        </md-button>
      </div>
    </div>
    <md-dialog :md-active.sync="createEntryDialogOpened" class="cal-entry-dialog">
      <create-entry-dialog
        :property-id="activePropertyId"
        :selected-start-date="activeStartDate"
        :readonly="!userRoleCanEditCalendar"
        @closed="onDialogClosed"
      ></create-entry-dialog>
    </md-dialog>
    <md-dialog :md-active.sync="updateEntryDialogOpened">
      <edit-entry-dialog
        :property-id="activePropertyId"
        :entry-id="activeEntryId"
        :readonly="!userRoleCanEditCalendar"
        @closed="onDialogClosed"
      ></edit-entry-dialog>
    </md-dialog>
    <md-dialog :md-active.sync="readonlyEntryDialogOpened">
      <readonly-entry-dialog
        :property-id="activePropertyId"
        :entry-id="activeEntryId"
        @closed="onDialogClosed"
      ></readonly-entry-dialog>
    </md-dialog>
    <md-dialog
      :md-active.sync="showTutorial"
      md-fullscreen
      style="width:100%;background-color:transparent"
    >
      <div class="tutorial-container">
        <b-row style="color: white;">
          <b-col>
            <h1>
              Your
              <u>Properties</u> are listed on the left.
            </h1>
            <md-icon class="md-size-5x" style="color:white">reply</md-icon>
          </b-col>
          <b-col>
            <h1>
              Next to each property, is current
              <u>Status</u> and details of the present events.
            </h1>
            <p
              class="moow-info-txt large"
              style="color:white"
            >Feel free to customize the size or the columns or hide competely.</p>
            <md-list style="background-color:#ffffffad">
              <md-list-item>
                <md-icon class="md-size-2x moow-info" :style="{ color: colors.prebooking }">label</md-icon>
                <span class="md-list-item-text">Unconfirmed deals (e.g booking requests)</span>
              </md-list-item>
              <md-list-item>
                <md-icon class="md-size-2x moow-info" :style="{ color: colors.booking }">label</md-icon>
                <span class="md-list-item-text">Confirmed deals</span>
              </md-list-item>
              <md-list-item>
                <md-icon class="md-size-2x moow-info" :style="{ color: colors.bookingLate }">label</md-icon>
                <span class="md-list-item-text">Deals ending soon</span>
              </md-list-item>
              <md-list-item>
                <md-icon class="md-size-2x moow-info" :style="{ color: colors.blocked }">label</md-icon>
                <span class="md-list-item-text">Blocked dates</span>
              </md-list-item>
            </md-list>
          </b-col>
          <b-col>
            <b-row align-v="start">
              <b-col>
                <h1>
                  <u>Events</u> can be added manually or will appear here after a booking application.
                </h1>
                <p class="moow-info-txt large" style="color:white">
                  <b>Double click</b> to edit or add.
                </p>
                <p
                  class="moow-info-txt large"
                  style="color:white"
                >Mouse wheel or ctrl+keypad to zoom.</p>
              </b-col>
            </b-row>
            <b-row align-v="end">
              <b-col>
                <h2>Restore zoom or scroll to current date</h2>
                <md-icon class="md-size-5x" style="color:white">redo</md-icon>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </md-dialog>

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import GSTC from "vue-gantt-schedule-timeline-calendar";
import GSTCDescriptor from "gantt-schedule-timeline-calendar";
import ItemMovement from "gantt-schedule-timeline-calendar/dist/ItemMovement.plugin.js";
import WeekendHighlight from "gantt-schedule-timeline-calendar/dist/WeekendHighlight.plugin.js";
import CreateEntryDialog from "@/components/property-calendar/dialogs/CreateEntryDialog.vue";
import EditEntryDialog from "@/components/property-calendar/dialogs/EditEntryDialog.vue";
import ReadonlyEntryDialog from "@/components/property-calendar/dialogs/ReadonlyEntryDialog.vue";
import { getProperties } from "@/listingFunctions";
import debounce from "lodash/debounce";
var lodash = require("lodash/function");
const lists = require("@/lists.js");

const subs = [];
const DEFAULT_ZOOM_LEVEL = 20;

export default {
  name: "PropertyCalendar",
  props: ["bus"],
  components: {
    GSTC,
    CreateEntryDialog,
    EditEntryDialog,
    ReadonlyEntryDialog,
  },
  async created() {
    this.$emit("emitCustomAction", {action:"hideSideMenu"})
    try {
      this.bus.$on("triggerCTA", (data) => {
        if (data && data.trigger == "changeOrder"){
          this.setPropertiesOrder(data.input)
        }
        else if (data && data.trigger == "changeFilter") {
          this.setPropertiesFilter(data.input);
        }
      });
      // window.addEventListener("click", this.handleMouseClick);
      await this.getEntries();
      // First, load initial set of properties.
      // Then, if there is still something available, load more until the end is reached:
      await this.loadAllProperties();
    } catch (error) {
      this.notifyUser("Server error", "Something is not right");
      console.error(error);
    } finally {
      this.propertiesLoaded = true;
    }
  },
  data() {
    return {
      nrOfDoubleClickHintsShown: 0,
      snackbarMessage: "",
      showSnackbar: false,
      colors: {
        prebooking: "#7bc043",
        prebookingHistory: "#7bc04340",
        booking: "#4899D599",
        bookingHistory: "#4899D540",
        block: "#41404299",
        blockHistory: "#41404240",
        bookingLate: "#F7676594",
      },
      gstcState: null,
      columnsConfig: {
        percent: 100,
        data: {
          propertyName: {
            id: "propertyName",
            data: "label",
            width: 200,
            header: {
              content: "",
            },
          },
          propertyStatus: {
            id: "propertyStatus",
            data: "status",
            width: 90,
            header: {
              content: "Status",
            },
          },
          propertyStatusPeriodStart: {
            id: "propertyStatusPeriodStart",
            data: "statusPeriodStart",
            width: 90,
            header: {
              content: "Start",
            },
          },
          propertyStatusPeriodEnd: {
            id: "propertyStatusPeriodEnd",
            data: "statusPeriodEnd",
            width: 90,
            header: {
              content: "End",
            },
          },
        },
      },
      pluginsConfig: [
        ItemMovement({
          moveable: "x",
          wait: 1000,
          collisionDetection: false,
        }),
        WeekendHighlight(),
      ],
      activeListingMetaData: [{ listingProgress: 0 }],
      draftListingMetaData: [{ listingProgress: 0 }],
      archivedListingMetaData: [{ listingProgress: 0 }],
      listingLoadErrors: [],
      createEntryDialogOpened: false,
      updateEntryDialogOpened: false,
      readonlyEntryDialogOpened: false,
      activePropertyId: "",
      activeEntryId: "",
      activeStartDate: null,
      propertiesLoaded: false,
      showTutorial: false,
      propertiesFilter: "",
      currentOrder: "vacancy",
    };
  },
  computed: {
    ...mapState({
      activeProperties: (state) => state.propertiesModule.activeProperties,
      draftProperties: (state) => state.propertiesModule.draftProperties,
      canLoadMoreActiveProperties: (state) =>
        state.propertiesModule.canLoadMoreActiveProperties,
      canLoadMoreDraftProperties: (state) =>
        state.propertiesModule.canLoadMoreDraftProperties,
      propertiesPageLimit: (state) => state.propertiesModule.pageLimit,
      propertiesRequestPending: (state) =>
        state.propertiesModule.propertiesRequestPending,
    }),
    ...mapState("propertyCalendarModule", ["entries"]),
    activePropertiesPageNumber() {
      return this.$store.getters.activePropertiesPageNumber;
    },
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
    },
    userRoleCanEditCalendar() {
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.accountWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    draftPropertiesPageNumber() {
      return this.$store.getters.draftPropertiesPageNumber;
    },
    earliestEntry() {
      if (!Array.isArray(this.entries) || !this.entries.length) {
          return null;
      }
      let result = this.entries[0];
      this.entries.forEach((entry) => {
        if (result.startDate > entry.startDate) {
          result = entry;
        }
      });

      return result;
    },
    chartStartDate() {
      if (!this.earliestEntry) {
          return null;
      }

      return moment(this.earliestEntry.startDate).subtract(5, "days");
    },
    canLoadProperties() {
      return (
        this.canLoadMoreActiveProperties || this.canLoadMoreDraftProperties
      );
    },
    rowsConfig() {
      let unsortedResult = [];
      const result = {};
      this.activeProperties.forEach((property) => {
        const row = this.transformPropertyToRow(property);
        if (!row || !property._id) {
          return;
        }
        unsortedResult.push(row);
        // result[property._id] = row;
      });
      this.draftProperties.forEach((property) => {
        const row = this.transformPropertyToRow(property);
        if (!row || !property._id) {
          return;
        }
        unsortedResult.push(row);
        // result[property._id] = row;
      });

      if (this.propertiesFilter) {
        unsortedResult = unsortedResult.filter((row) => {
          return (
            row.label
              .toLowerCase()
              .indexOf(this.propertiesFilter.toLowerCase()) >= 0
          );
        });
      }

      var orderingMarker;
      if (this.currentOrder == "address") orderingMarker = "label";
      else if (this.currentOrder == "vacancy") orderingMarker = "upcomingVacancyDate";

      let sortedResult = unsortedResult.sort((left, right) => {
        if (!left[orderingMarker]) {
          return 1;
        }
        if (!right[orderingMarker]) {
          return -1;
        }

        var leftValue, rightValue
        if(orderingMarker == "upcomingVacancyDate"){
          leftValue = new Date(left[orderingMarker]);
          rightValue = new Date(right[orderingMarker]);
        }else {
          leftValue = left[orderingMarker];
          rightValue = right[orderingMarker];
        }
        
        if (leftValue < rightValue) {
          return -1;
        }
        if (leftValue > rightValue) {
          return 1;
        }

        return 0;
      });

      sortedResult.forEach((row) => {
        result[row.id] = row;
      });

      return result;
    },
    noProperties() {
      return !this.activeProperties.length && !this.draftProperties.length;
    },
    itemsConfig() {
      const result = {};
      this.entries.forEach((entry) => {
        result[entry.id] = this.transformEntryToItem(entry);
      });

      return result;
    },
    generalConfig() {
      return {
        height: window.innerHeight - 124,
        list: {
          rows: this.rowsConfig,
          columns: this.columnsConfig,
        },
        chart: {
          items: this.itemsConfig,
          time: {
            period: "day",
            from: this.chartStartDate ? this.chartStartDate.format("X") * 1000 : null,
            to: moment().add(5, "years").format("X") * 1000,
          },
        },
        plugins: this.pluginsConfig,
        actions: {
          "chart-timeline-grid-row-block": [this.handleDoubleClickByRow],
          "chart-timeline-items-row-item": [this.handleClickByEntry],
          "list-column-row": [this.handleColumnRowClick],
        },
      };
    },
    infoSnackbarText() {
      if (this.userRoleCanEditCalendar)
        return "Double click to add or open an event";
      else
        return "Double click to see event details. Your role cannot edit or add events";
    },
  },
  methods: {
    ...mapActions("propertyCalendarModule", ["getEntries"]),
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    handleMouseClick: lodash.debounce(function (e) {
      if (this.nrOfDoubleClickHintsShown > 3) return;
      this.nrOfDoubleClickHintsShown++;
      if (
        this.nrOfDoubleClickHintsShown == 1 ||
        this.nrOfDoubleClickHintsShown == 3
      ) {
        this.showSnackbar = true;
        this.snackbarMessage = this.infoSnackbarText;
      }
    }, 1000),
    toggleTutorial(value) {
      this.showTutorial = value;
    },
    transformEntryToItem(entry) {
      return {
        id: entry.id,
        rowId: entry.propertyId,
        label: this.getEntryLabel(entry),
        moveable: false, //this.isInteractive(entry) ? 'x' : false,
        resizeable: false, //this.isInteractive(entry),
        readonly: this.isReadonly(entry),
        time: {
          start: new Date(entry.startDate).getTime(),
          end: new Date(entry.endDate).getTime(),
        },
        style: {
          background: this.getEntryColor(entry),
        },
      };
    },
    transformPropertyToRow(property) {
      if (!property._id) {
        return null;
      }
      // TODO: Uncomment IF you want to hide drafts without entries.
      // const entry = this.entries.find(item => item.propertyId === property._id);
      // if (property.availDet.status === "draft" && !entry) {
      //   return null;
      // }

      // TODO: move to upper level
      const DATE_FORMAT = "DD.MM.YYYY";
      var label = this.getDisplayAddress(property);
      !label ? (label = this.getTitle(property)) : void 0;

      var subType = this.getSubType(property);
      subType ? (label = label + " (" + subType + ")") : void 0;

      const { activeEntry, nextEntry } = this.getPropertyOccupationData(
        property
      );

      return {
        id: property._id,
        label: label || `Property ${property.maaklerID}`,
        status: activeEntry ? "Occupied" : "Vacant",
        statusPeriodStart: activeEntry
          ? `${moment(activeEntry.startDate).format(DATE_FORMAT)}`
          : "",
        statusPeriodEnd: activeEntry
          ? activeEntry.termless
            ? "Termless"
            : `${moment(activeEntry.endDate).format(DATE_FORMAT)}`
          : "",
        upcomingVacancyDate: activeEntry
          ? activeEntry.termless
            ? new Date("2050-01-01")
            : activeEntry.endDate
          : null,
        property,
      };
    },
    getTitle(property) {
      try {
        return property.marketingDet.shortDesc;
      } catch (error) {
        return "";
      }
    },
    getSubType(property) {
      var r;
      try {
        for (let i = 0; i < lists.subPropertyTypeList.length; i++) {
          const subType = lists.subPropertyTypeList[i];
          if (
            subType.value &&
            subType.value === property.genDet.propType.subType
          )
            return subType.text;
        }
        return "";
      } catch (ex) {
        return "";
      }
    },
    getDisplayAddress(property) {
      try {
        if (!property.location.address.street) return "";
        return (
          property.location.address.street +
          " " +
          property.location.address.number +
          "- " +
          property.location.address.apartNumber
        );
      } catch (ex) {
        return "";
      }
    },
    isInteractive(entry) {
      return entry.creatorType !== "system";
    },
    isReadonly(entry) {
      return entry.creatorType === "system";
    },
    getPropertyOccupationData(property) {
      const currentDate = new Date();
      let activeEntry = null;
      let nextEntry = null;
      for (const entry of this.entries) {
        if (entry.propertyId !== property._id) {
          continue;
        }
        if (
          activeEntry &&
          new Date(entry.startDate) > new Date(activeEntry.startDate)
        ) {
          nextEntry = entry;
          break;
        }
        if (
          currentDate >= new Date(entry.startDate) &&
          currentDate <= new Date(entry.endDate)
        ) {
          activeEntry = entry;
        }
      }

      return {
        activeEntry,
        nextEntry,
      };
    },
    getEntryColor(entry) {
      var end = moment(new Date(entry.endDate));
      var today = moment();
      var daysPassed = end.diff(today, "days");
      switch (entry.status) {
        case "prebooked":
          if (daysPassed < 0) return this.colors.prebookingHistory;
          return this.colors.prebooking;
        case "booked":
          if (daysPassed < 0) return this.colors.bookingHistory;
          if (daysPassed <= 15) return this.colors.bookingLate;
          return this.colors.booking;
        case "blocked":
          if (daysPassed < 0) return this.colors.blockHistory;

          return this.colors.block;
      }
    },
    getEntryLabel(entry) {
      if (entry.tenantName || entry.tenantSurname) {
        return `${entry.tenantName || ""} ${entry.tenantSurname || ""}`;
      }
      if (entry.statusComment) {
        return entry.statusComment;
      }

      return `${entry.status} (${entry.creatorType})`;
    },
    handleDoubleClickByRow(element, data) {
      const listener = element.addEventListener("dblclick", () => {
        const { id: propertyIdWithDate } = data;
        const [propertyId, date] = propertyIdWithDate.split(":");
        this.showCreateEntryDialog(propertyId, date.substring(0, 10));
      });

      return {
        update(element, newData) {
          data = newData;
        },
        destroy(element, data) {
          element.removeEventListener("dblclick", listener);
        },
      };
    },
    handleClickByEntry(element, data) {
      try {
        const listener = element.addEventListener("click", () => {
          const {
            item: { id: entryId, readonly } = {},
            row: { id: propertyId } = {},
          } = data;
          if (readonly) {
            this.showReadonlyEntryDialog(propertyId, entryId);
          } else {
            this.showEditEntryDialog(propertyId, entryId);
          }
        });

        return {
          update(element, newData) {
            data = newData;
          },
          destroy(element, data) {
            element.removeEventListener("dblclick", listener);
          },
        };
      } catch (error) {
        console.error(error);
      }
    },
    handleColumnRowClick(element, data) {
      try {
        const listener = element.addEventListener("dblclick", () => {
          const rowConfig = this.rowsConfig[data.rowId];
          if (!rowConfig || !rowConfig.property) {
            return;
          }
          this.navigateTo("listing", {
            listingId: rowConfig.property.maaklerID,
          });
        });

        return {
          update(element, newData) {
            data = newData;
          },
          destroy(element, data) {
            element.removeEventListener("dblclick", listener);
          },
        };
      } catch (error) {
        console.error(error);
      }
    },
    showCreateEntryDialog(propertyId, date) {
      if (this.userRoleCanEditCalendar) {
        this.activePropertyId = propertyId;
        this.activeStartDate = new Date(date);
        this.createEntryDialogOpened = true;
      }
    },
    showEditEntryDialog(propertyId, entryId) {
      this.activePropertyId = propertyId;
      this.activeEntryId = entryId;
      this.updateEntryDialogOpened = true;
    },
    showReadonlyEntryDialog(propertyId, entryId) {
      this.activePropertyId = propertyId;
      this.activeEntryId = entryId;
      this.readonlyEntryDialogOpened = true;
    },
    onDialogClosed() {
      this.activePropertyId = "";
      this.activeEntryId = "";
      this.activeStartDate = null;
      this.createEntryDialogOpened = false;
      this.updateEntryDialogOpened = false;
      this.readonlyEntryDialogOpened = false;
    },
    onState(state) {
      this.gstcState = state;
      this.scrollToTime(moment());
    },
    limitScrollLeft(totalViewDurationPx, chartWidth, scrollLeft) {
      const width = totalViewDurationPx - chartWidth;
      if (scrollLeft < 0) {
        scrollLeft = 0;
      } else if (scrollLeft > width) {
        scrollLeft = width;
      }

      return Math.round(scrollLeft);
    },
    scrollToTime(date) {
      const gstc = GSTCDescriptor({
        element: this.$refs.gstc.$refs.gstc,
        state: GSTCDescriptor.api.stateFromConfig(this.generalConfig),
      });
      const time = gstc.state.data._internal.chart.time;
      const chartWidth = gstc.state.data._internal.chart.dimensions.width;
      const halfTime = (chartWidth / 2) * time.timePerPixel;
      const leftGlobal = date.valueOf() - halfTime - time.finalFrom;

      const offsetLeft = this.limitScrollLeft(
        time.totalViewDurationPx,
        chartWidth,
        leftGlobal / time.timePerPixel
      );
      setTimeout(() => {
        document.getElementsByClassName(
          "gantt-schedule-timeline-calendar__horizontal-scroll"
        )[0].scrollLeft = offsetLeft - 300;
      }, 0);
    },
    centerToCurrentDate() {
      this.scrollToTime(moment());
    },
    goToProperties() {
      this.navigateTo("dashboard");
    },
    navigateTo(where, params) {
      this.$router.push({
        name: where,
        params: params,
      });
    },
    resetZoom() {
      this.gstcState.update("config.chart.time.zoom", DEFAULT_ZOOM_LEVEL);
    },
    async loadMoreProperties() {
      const promises = [];
      if (this.canLoadMoreActiveProperties) {
        promises.push(
          getProperties(
            "active",
            this.listingLoadErrors,
            this.activeListingMetaData,
            this.activePropertiesPageNumber,
            this.propertiesPageLimit
          )
        );
      }
      if (this.canLoadMoreDraftProperties) {
        promises.push(
          getProperties(
            "draft",
            this.listingLoadErrors,
            this.draftListingMetaData,
            this.draftPropertiesPageNumber,
            this.propertiesPageLimit
          )
        );
      }
      return await Promise.all(promises);
    },
    async loadAllProperties(depth = 0) {
      try {
        if (!this.canLoadProperties || depth >= 20) {
          return;
        }
        try {
          await this.loadMoreProperties();
        } catch (error) {
          console.error(error);
          return;
        }
        await this.loadAllProperties(depth + 1);
      } catch (error) {
        console.error(error);
      }
    },
    setPropertiesFilter: debounce(function (pf) {
      try {
        if (pf && pf.length > 2) this.propertiesFilter = pf;
        else this.propertiesFilter = "";
      } catch (err) {
      }
    }, 300),
    setPropertiesOrder(ordering){
      this.currentOrder = ordering;
    }
  },
  beforeDestroy() {
    subs.forEach(unsub => unsub());
    // document.removeEventListener("click", this.handleMouseClick);
  },
  watch: {
    itemsConfig(configItems) {
      if (!this.gstcState) {
        return;
      }
      this.gstcState.update("config.chart.items", configItems);
    },
    rowsConfig(value) {
      if (!this.gstcState) {
        return;
      }
      this.gstcState.update("config.list.rows", value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global.css";

.table-container {
  //padding-top: 5px;
  //padding-left: 75px;
  min-height: 845px;
  position: relative;
}

.tools-panel {
  opacity: 0.4;
  display: flex;
  position: fixed;
  right: 1.5em;
  bottom: 6em;
  align-items: center;

  &:hover {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.gantt-schedule-timeline-calendar__chart-timeline-grid-row-block:hover {
  background-color: rgba(237, 241, 242, 0.75);
  cursor: pointer;
}

.gantt-schedule-timeline-calendar__chart-timeline-items-row-item,
.gantt-schedule-timeline-calendar__list-column-row {
  cursor: pointer;
}

.gantt-schedule-timeline-calendar__list-column-rows,
.gantt-schedule-timeline-calendar__list-column-header {
  // background-color: #fea49f42;
  background-color: white;

}

.gantt-schedule-timeline-calendar__list-toggle {
  top: 65vh;
  background-color:  #fea49f42;
  color: white;
}

.cal-entry-dialog {
  overflow-y: scroll;
}

.gantt-schedule-timeline-calendar__chart-timeline-items-row-item-label {
  font-weight: bolder;
}

.properties-filter-input {
  max-width: 470px;
}
</style>



// WEBPACK FOOTER //
// src/components/property-calendar/PropertyCalendar.vue